import {
  OUTCOME_APP_PROMOTION,
  OUTCOME_AWARENESS,
  OUTCOME_ENGAGEMENT,
  OUTCOME_LEADS,
  OUTCOME_SALES,
  OUTCOME_TRAFFIC,
  REACH
} from '../../../../../constants/campaigns'

interface ObjectiveOption {
  value: string
  label: string
}

export const objectivesList: ObjectiveOption[] = [
  {
    value: REACH,
    label: 'Reach'
  },
  {
    value: OUTCOME_AWARENESS,
    label: 'Awareness'
  },
  {
    value: OUTCOME_SALES,
    label: 'Sales'
  },
  {
    value: OUTCOME_LEADS,
    label: 'Leads'
  },
  {
    value: OUTCOME_ENGAGEMENT,
    label: 'Engagement'
  },
  {
    value: OUTCOME_TRAFFIC,
    label: 'Traffic'
  },
  {
    value: OUTCOME_APP_PROMOTION,
    label: 'App Promotion'
  }
]
